import MemberLoginDialogComponent from '../components/MemberLoginDialog/viewer/MemberLoginDialog';
import RequestPasswordResetDialogComponent from '../components/RequestPasswordResetDialog/viewer/RequestPasswordResetDialog';
import SignUpDialogComponent from '../components/SignUpDialog/viewer/SignUpDialog';


const MemberLoginDialog = {
  component: MemberLoginDialogComponent
};

const RequestPasswordResetDialog = {
  component: RequestPasswordResetDialogComponent
};

const SignUpDialog = {
  component: SignUpDialogComponent
};


export const components = {
  ['MemberLoginDialog']: MemberLoginDialog,
  ['RequestPasswordResetDialog']: RequestPasswordResetDialog,
  ['SignUpDialog']: SignUpDialog
};

